import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUndo, faRedo } from "@fortawesome/free-solid-svg-icons";
import { useRecoilState, useSetRecoilState } from "recoil";
import { alertMessageState, loadingState } from "src/atom/LoadingState";
import { Modal, Button } from "react-bootstrap";
import { downloadChildFile } from "src/services/MainPage/GenericService";
import { getExtenstion } from "src/utils";

const PreviewImage = ({ parentQuestion, data, isChild }) => {
  const [showPreview, setShowPreview] = useState(false);
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [downloadLabel, setDownloadLabel] = useState("");
  const enableLoader = useSetRecoilState(loadingState);
  const [, setAlertMessage] = useRecoilState(alertMessageState);

  const [fileType, setFileType] = useState("image");
  const [zoom, setZoom] = useState(1);
  const [imageUrl, setImageUrl] = useState(null);
  const [rotation, setRotation] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => {
    enableLoader(true);
    downloadChildFile(data, parentQuestion?.id).then((response) => {
      enableLoader(false);
      if (response.success === true) {
        setImageUrl(response.body.fileContent);
        if ((response?.body?.fileName.toString().split(".")[1]) === "pdf") {
          setFileType("pdf");
        }
      } else {
        setAlertMessage("Can't load image/PDF");
      }
    });
    setShowModal(!showModal);
  };

  const zoomIn = () => {
    setZoom((prevZoom) => prevZoom + 0.1);
  };

  const zoomOut = () => {
    setZoom((prevZoom) => Math.max(prevZoom - 0.1, 1));
  };

  const rotateLeft = () => {
    setRotation((prevRotation) => prevRotation - 90);
  };

  const rotateRight = () => {
    setRotation((prevRotation) => prevRotation + 90);
  };

  useEffect(() => {
    if (data && parentQuestion) {
      setIsDataAvailable(true);
      setShowPreview(parentQuestion.preview);
      setDownloadLabel(parentQuestion.previewLabel);
    }
  }, [data, parentQuestion]);

  return (
    <>
      {showPreview && isDataAvailable && (
        <img
          src={`data:image/png;base64, ${previewFile}`}
          alt="Preview"
          style={{ maxWidth: "100%", height: "auto" }}
        />
      )}

      {!showPreview && isDataAvailable && (
        <button
          type="button"
          className="btn btn-sm btn-link"
          style={{ fontSize: "20px", textDecoration: "none" }}
          onClick={toggleModal}
        >
          {downloadLabel || "Download"}
        </button>
      )}

      <Modal show={showModal} size="lg" centered>
        <Modal.Header>
          <Modal.Title>Preview</Modal.Title>
          <Button
            variant="secondary"
            onClick={toggleModal}
            className="text-white"
            style={{ backgroundColor: "#6c757d", borderColor: "#6c757d" }}
          >
            Close
          </Button>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              height: "70vh",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "80%",
                overflow: "auto",
                position: "relative",
              }}
            >
              {fileType === "pdf" ? (
                <iframe
                  src={`data:application/pdf;base64,` + imageUrl}
                  title="PDF Viewer"
                  width="100%"
                  height="100%"
                  style={{ border: "none" }}
                />
              ) : (
                <iframe
                  srcDoc={`<html><body style="margin:0; display:flex; justify-content:center; align-items:center;"><img src="data:image/png;base64,${imageUrl}" style="transform: scale(${zoom}) rotate(${rotation}deg); transform-origin: center center; width:auto; height:auto; max-width: 100%; max-height: 100%;" /></body></html>`}
                  title="Image Viewer"
                  width="100%"
                  height="100%"
                  style={{
                    border: "none",
                    position: "absolute",
                    top: 0,
                    left: 0,
                  }}
                />
              )}
            </div>

            {fileType !== "pdf" && (
              <div style={{ marginTop: "10px" }}>
                <button
                  className="btn btn-link"
                  onClick={rotateLeft}
                  style={{ fontSize: "30px" }}
                >
                  <FontAwesomeIcon icon={faUndo} />
                </button>
                <button className="btn btn-primary ms-3" onClick={zoomIn}>
                  Zoom In
                </button>
                <button className="btn btn-primary ms-3" onClick={zoomOut}>
                  Zoom Out
                </button>
                <button
                  className="btn btn-link"
                  style={{ fontSize: "30px" }}
                  onClick={rotateRight}
                >
                  <FontAwesomeIcon icon={faRedo} />
                </button>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PreviewImage;
